import { createSlice } from "@reduxjs/toolkit";

const storedUser = JSON.parse(localStorage.getItem("userData"));

const userData = storedUser || {
  id: null,
  user_name: null,
  first_name: null,
  last_name: null,
  email: null,
  token: null,
  location: null,
  bio: null,
  rating: null,
  facebook: null,
  twitter: null,
  whatsapp: null,
  image: null,
  verified: false,
};

const initialState = {
  userData,
  password: null,
  isSigned: !!storedUser?.token || !!userData.token,
  error: null,
};

const usersSlice = createSlice({
  name: "USERS",
  initialState,
  reducers: {
    addUser: (state, action) => {
      const { response, token } = action.payload;
      state.userData = { ...response, token: token };
      state.isSigned = true;
      localStorage.setItem("userData", JSON.stringify(state.userData));
    },
    editUser: (state, action) => {
      const { response, token } = action.payload;
      state.userData = { ...response, token: token };
      localStorage.setItem("userData", JSON.stringify(state.userData));
    },
    addPassword: (state, action) => {
      state.password = action.payload.password;
    },
    removePassword: (state) => {
      state.password = null;
    },
    signIn: (state) => {
      state.isSigned = true;
      state.error = null;
    },
    signOut: (state) => {
      state.userData = {
        id: null,
        user_name: null,
        first_name: null,
        last_name: null,
        email: null,
        token: null,
        location: null,
        bio: null,
        rating: null,
        facebook: null,
        twitter: null,
        whatsapp: null,
        image: null,
        verified: false,
      };
      state.password = null;
      state.isSigned = false;
      state.error = null;
      localStorage.removeItem("userData");
    },
    userVerify: (state) => {
      state.userData.verified = true;
      localStorage.setItem("userData", JSON.stringify(state.userData));
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  addUser,
  editUser,
  addPassword,
  removePassword,
  signIn,
  signOut,
  userVerify,
  setError,
} = usersSlice.actions;

export default usersSlice.reducer;
